// src/features/eventos/hooks/useAccordionState.js
import { useCallback, useState } from "react";

/**
 * Hook genérico para manejar "sets" de acordeones abiertos
 * y un "sub-accordion" por índice (objeto idx -> Set(keys)).
 */
export function useAccordionState() {
    const [openCacerias, setOpenCacerias] = useState(new Set());
    const [openParts, setOpenParts] = useState(new Set());
    const [openActs, setOpenActs] = useState(new Set());
    const [openMenus, setOpenMenus] = useState(new Set());

    // sub-accordion por índice: { [idx]: Set(keys) }
    const [openSubPart, setOpenSubPart] = useState({});

    const toggleInSet = useCallback((setter, idx) => {
        setter((prev) => {
            const next = new Set(prev);
            next.has(idx) ? next.delete(idx) : next.add(idx);
            return next;
        });
    }, []);

    const toggleSub = useCallback((idx, key) => {
        setOpenSubPart((prev) => {
            const set = new Set(prev[idx] || []);
            set.has(key) ? set.delete(key) : set.add(key);
            return { ...prev, [idx]: set };
        });
    }, []);

    const isSubOpen = useCallback((idx, key) => {
        return Boolean(openSubPart[idx]?.has(key));
    }, [openSubPart]);

    return {
        openCacerias,
        setOpenCacerias,
        openParts,
        setOpenParts,
        openActs,
        setOpenActs,
        openMenus,
        setOpenMenus,
        openSubPart,
        setOpenSubPart,

        // toggles
        toggleCaceria: (idx) => toggleInSet(setOpenCacerias, idx),
        togglePart: (idx) => toggleInSet(setOpenParts, idx),
        toggleAct: (idx) => toggleInSet(setOpenActs, idx),
        toggleMenu: (idx) => toggleInSet(setOpenMenus, idx),
        toggleSub,

        // isOpen
        isCaceriaOpen: (idx) => openCacerias.has(idx),
        isPartOpen: (idx) => openParts.has(idx),
        isActOpen: (idx) => openActs.has(idx),
        isMenuOpen: (idx) => openMenus.has(idx),
        isSubOpen,
    };
}
